import Footer from "@/components/globals/Footer";
import Navbar from "@/components/globals/Navbar";

type Props = {
  children?: React.ReactNode;
};

const LayoutContainer = ({ children }: Props) => {
  return (
    <div id="LayoutContainer main" className="font-dm-sans text-dark relative w-full">
      <Navbar />
      <div>{children}</div>
      <Footer />
    </div>
  );
};

export default LayoutContainer;
